import LinkButton from 'components/LinkButton';
import NavigationTabs from 'components/Navigation/NavigationTabs';
import SectionHeader from 'components/SectionHeader';
import {H2} from 'components/Typography';
import {Trans, useTranslation} from 'react-i18next';
import {useBackend} from 'state/backend';
import {Backend} from 'types/api';

export type RicohDirectDebitBackendData = Backend<{
    invitationLink: string;
}>;

const RicohDirectDebit = () => {
    const {
        data: {invitationLink},
    } = useBackend<RicohDirectDebitBackendData>();

    const {t} = useTranslation('Partner.Integrations.RicohDirectDebit');

    return (
        <>
            <NavigationTabs.Partner selection="integrations" />
            <SectionHeader subtitle={t('subtitle')} title={t('title')} />
            <p>{t('paragraphRicohDirectDebitDescription')}</p>
            <p>{t('paragraphRicohDirectDebitFootnote')}</p>
            <p>
                {t('paragraphRicohDirectDebitDemo')}
                <br />
                <a
                    href="mailto:sales@makeleaps.com"
                    rel="opener noreferrer"
                    target="_blank"
                >
                    sales@makeleaps.com
                </a>
                <br />
                <Trans
                    components={[
                        <a
                            href="https://webform.ricoh.com/form/pub/e00156/dd-application-form"
                            key={0}
                            rel="opener noreferrer"
                            target="_blank"
                        >
                            {' '}
                        </a>,
                    ]}
                    i18nKey="paragraphRicohDirectDebitForm"
                    t={t}
                />
            </p>
            <H2>{t('titleRicohDirectDebitRegistered')}</H2>
            <LinkButton
                className="mb-2 mt-4"
                href={invitationLink}
                kind="primary"
                size="sm"
                target="_blank"
            >
                {t('buttonRicohDirectDebitApp')}
            </LinkButton>
            <p>{t('paragraphRicohDirectDebitTrial')}</p>
        </>
    );
};

export default RicohDirectDebit;
